"use client"
import { ICustomImage } from "@filmweb/sanity-types";
import dynamic from 'next/dynamic';
import { useState } from "react";
import Button from "src/components/button/Button";
import CmsImage from "src/components/images/CmsImage";
import LoadingIndicator from "src/components/loadingindicator/LoadingIndicator";
import CameraSvg from "src/components/svg/CameraSvg";
import styles from './ImageGalleryPlaceholder.module.css';

const DynamicImageGalleryDisplay = dynamic(() => import('./ImageGalleryDisplay'), {
    loading: () => <LoadingIndicator />,
});

//#region [Props]
type ImageGalleryPlaceholderProps = {
    images?: ICustomImage[] | null;
    placeholderImage?: ICustomImage;
    placeholderWidth?: number;
    placeholderAspect?: number;
    placeholderSizes?: string;
    placeholderUnoptimized?: boolean;
    placeholderPriority?: boolean;
};
//#endregion

//#region [Component]
export default function ImageGalleryPlaceholder({ images, placeholderImage, placeholderWidth, placeholderAspect, placeholderSizes, placeholderUnoptimized, placeholderPriority }: ImageGalleryPlaceholderProps) {
    const [showGalleryDialog, setShowGalleryDialog] = useState(false);
    if ((images?.length ?? 0) < 2) {
        return null;
    }

    return <>
        <div className={styles.SImageGalleryContainer}>
            <CmsImage className={styles.SPlaceholderImage} image={placeholderImage!} alt="Se bildeserie" sizes={placeholderSizes} width={placeholderWidth} nonPosterAspect={placeholderAspect} unoptimized={placeholderUnoptimized} priority={placeholderPriority} />
            <Button className={styles.SShowButton} icon={<CameraSvg className={styles.SCameraSvg} />} text="Se bildegalleri" onClick={() => setShowGalleryDialog(true)} />

        </div>
        {showGalleryDialog && <DynamicImageGalleryDisplay
            images={images!}
            onClose={() => setShowGalleryDialog(false)} />}
    </>;
}
//#endregion

//#region [Styles]
//#endregion
